<template>
  <div>
    <h1 class="flex mb-8 font-bold text-3xl group">
      <inertia-link class="flex text-indigo-400 group-hover:text-indigo-600" :href="route('actions')">
        <icon name="request" class="w-6 h-9 mr-3 fill-indigo-400 group-hover:fill-indigo-600" /> Ações /
      </inertia-link>
      <span class="ml-1 font-medium">
        Criar
      </span>
    </h1>

    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input
            v-model="form.title"
            :error="form.errors.title"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Título"
          />

          <select-input v-model="form.topic" :error="form.errors.topic" class="pr-6 pb-8 w-full lg:w-1/2" label="Tópico">
            <option :value="null" />
            <option v-for="topic in topics" :key="topic.value" :value="topic.value">{{ topic.label }}</option>
          </select-input>

          <textarea-input
            v-model="form.body"
            :error="form.errors.body"
            class="pr-6 pb-8 w-full"
            label="Sugestões"
            :rows="4"
          />
        </div>

        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Criar Ação</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import TextareaInput from '@/Shared/TextareaInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo: { title: 'Criar Ação' },
  components: {
    Icon,
    TextInput,
    SelectInput,
    TextareaInput,
    LoadingButton,
  },
  layout: Layout,
  remember: 'form',
  props: {
    topics: Array,
  },
  data() {
    return {
      form: this.$inertia.form({
        topic: null,
        title: null,
        body:  null,
      }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('actions.store').url())
    },
  },
}
</script>
